var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speaker-time"},[_c('h2',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"speaker-time-value white--text"},[_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }